/** Misma llave que unique_tareo_empresa_empleado_proyecto_fecha. */
export function claveUnicaTareo({ empresa_id, empleado_id, proyecto_id, fecha } = {}) {
  const fechaYmd = String(fecha ?? '').trim().split('T')[0].split(' ')[0].slice(0, 10);
  return `${Number(empresa_id) || 0}|${Number(empleado_id) || 0}|${Number(proyecto_id) || 0}|${fechaYmd}`;
}

export function fechaTareoYmd(valor) {
  if (valor == null || valor === '') return '';
  const s = String(valor).trim();
  if (s.includes('T')) return s.split('T')[0].slice(0, 10);
  if (s.includes(' ')) return s.split(' ')[0].slice(0, 10);
  return s.slice(0, 10);
}

export function mapaClavesTareosExistentes(lista) {
  const mapa = new Map();
  (Array.isArray(lista) ? lista : []).forEach((t) => {
    if (!t) return;
    const clave = claveUnicaTareo({
      empresa_id: t.empresa_id,
      empleado_id: t.empleado_id,
      proyecto_id: t.proyecto_id,
      fecha: fechaTareoYmd(t.fecha),
    });
    if (!mapa.has(clave)) mapa.set(clave, t);
  });
  return mapa;
}

export function nombreProyectoTareo(tareo, proyectos = []) {
  const desdeRelacion = tareo?.proyecto?.nombre
    || tareo?.proyecto?.descripcion
    || tareo?._sedeNombre;
  if (desdeRelacion) return String(desdeRelacion);
  const id = tareo?.proyecto_id;
  const hallado = (proyectos || []).find((p) => String(p.id) === String(id));
  return hallado?.nombre || (id != null ? `Proyecto ${id}` : 'sin proyecto');
}

/** Texto de dónde ya está el tareo (proyecto, tipo y horario). */
export function describirTareoRegistrado(tareo, proyectos = []) {
  if (!tareo) return 'ya está registrado';
  const proyecto = nombreProyectoTareo(tareo, proyectos);
  const tipo = tareo.tipo_evento || 'sin tipo';
  const he = tareo.hora_entrada_real || tareo.hora_entrada_teorica || '';
  const hs = tareo.hora_salida_real || tareo.hora_salida_teorica || '';
  const horario = he && hs ? ` ${he}–${hs}` : '';
  return `ya está en ${proyecto} como ${tipo}${horario}`;
}
